import { Checkbox as CheckboxComponent } from '@/components/ui/checkbox';
import { cn } from '@/lib/utils';

interface CheckboxProps extends React.ComponentProps<typeof CheckboxComponent> {
  isChecked?: boolean;
  isDisabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

const Checkbox = ({ isChecked, isDisabled, onClick, className, ...props }: CheckboxProps) => {
  const handleChange = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isDisabled) return;
    onClick(e);
  };

  return (
    <CheckboxComponent
      checked={isChecked}
      disabled={isDisabled}
      onClick={handleChange}
      className={cn(className)}
      {...props}
    />
  );
};

export default Checkbox;
